<template lang="pug">
  div.footer-docs
    span.footer-docs__item(v-for="(doc, index) in docs", :key="index")
      a(v-if="doc.show" :href="doc.link" target="_blank") {{ $t(doc.i18ntext) }}
      span.footer-docs__separator(v-if="showSeparator(index)") -

</template>
<script>
import env from "@godweb/frontend-base/src/libs/tools/Environment";
export default {
  name: "FooterDocs",
  data() {
    return {
      docs: [
        {
          i18ntext: "footer.terms",
          link: "https://documentation.my.games/terms/mygames_tou",
          show: env.isMyGames(),
        },
        {
          i18ntext: "footer.privacy_policy",
          link: "https://documentation.my.games/terms/mygames_privacy",
          show: env.isMyGames(),
        },
        {
          i18ntext: "footer.eula",
          link: "https://documentation.my.games/terms/mygames_eula",
          show: true,
        },
      ],
    };
  },

  methods: {
    showSeparator(index) {
      return env.isMyGames() && index !== this.docs.length - 1;
    },
  },
};
</script>
